import React from "react";

const About = () => {
  return (
    <div id="about" className="bg-primary flex flex-col md:fex-row  gap-16 md:gap-16  py-20 px-4 md:px-16 ">
      <div>
        <h1 className="text-xl md:text-5xl font-bold ">The Origin of ELEPHONK</h1>
        <div className="h-0.5 w-[20%] my-4 bg-white"></div>
        <div className="text-sm md:text-xl " >
        ELEPHONK was born out of a vision  to create a memecoin that goes beyond
          the norm. Inspired by the success of other dog-themed meme projects on
          Solana, ELEPHONK joins the pack with the goal of bringing dog lovers and
          crypto enthusiasts together on this exciting blockchain. The idea was
          to create a fun and engaging digital currency that incorporates not
          only humor but also meaningful utilities.
        </div>
      </div>
      <div>
        <h1 className="text-xl md:text-5xl font-bold">What is ELEPHONK</h1>
        <div className="h-0.5 w-[20%] my-4 bg-white"></div>

        <div  className="text-sm md:text-xl">
        ELEPHONK is a revolutionary digital currency on the Solana blockchain. It
          is designed for simplicity, security, and accessibility, providing a
          seamless crypto experience for both experienced traders and curious
          beginners. As a memecoin, ELEPHONK represents a movement to make Solana
          more inclusive and welcoming for everyone.
        </div>
      </div>
    </div>
  );
};

export default About;
